import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';
import { OpenLinkById } from '../../services/openlinkbyid';
import { forkJoin } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-related-praposed-asus',
  templateUrl: './related-praposed-asus.component.html',
  styleUrls: ['./related-praposed-asus.component.css'],
  providers: [DatePipe]
})
export class RelatedPraposedASUSComponent implements OnInit {

  constructor(private commonDataService: CommonDataService, private graphQlService: GraphqlService, private openlink: OpenLinkById, private router: Router, private datePipe: DatePipe) {

  }

  @Output() myEvent = new EventEmitter<string>();

  title;
  content;
  parameter;
  proposedASUs_header;
  proposedASUs_description;
  proposedASUs_learnMore;
  proposedASUs_issued;
  proposedASUs_commentdue;
  proposedASUs_body;
  proposedASUs_forMoreInformation;
  myDate = new Date();
  currentdate;
  ngOnInit(): void {
    this.currentdate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.commonDataService.ASUParams.subscribe(params => {
      this.parameter = params.split("-");
      this.getRelatedProposedASU();
    })
  }
  source;
  
  getRelatedProposedASU() {
    this.commonDataService.showLoader.next(true);
    forkJoin([
      this.graphQlService.getWhatLinksHereLabels(),
      this.graphQlService.getRelatedpropsedASU(this.parameter[0], this.parameter[1], this.parameter[2])
    ]).subscribe(([WhatLinkslabels, relatedProposedASUdata]) => {
      let labels = WhatLinkslabels.content.data.labels;
      this.proposedASUs_header = labels.filter(x => x.key === "proposedASUs_header").map(y => y.value);
      this.proposedASUs_description = labels.filter(x => x.key === "proposedASUs_description").map(y => y.value);
      this.proposedASUs_learnMore = labels.filter(x => x.key === "proposedASUs_learnMore").map(y => y.value);
      this.proposedASUs_issued = labels.filter(x => x.key === "proposedASUs_issued").map(y => y.value);
      this.proposedASUs_commentdue = labels.filter(x => x.key === "proposedASUs_commentdue").map(y => y.value);
      this.proposedASUs_body = labels.filter(x => x.key === "proposedASUs_body").map(y => y.value);
      this.proposedASUs_forMoreInformation = labels.filter(x => x.key === "proposedASUs_forMoreInformation").map(y => y.value);
      this.source = relatedProposedASUdata.hits.hitsList;
      this.commonDataService.showLoader.next(false);
      
      this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  openLinkById(event) {
    this.openlink.openLinkById(event);
  }

  Openlink(event) {
    this.router.navigate([event.currentTarget.id]);
    this.myEvent.emit();


  }


}
